function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M2.182 16.44a.976.976 0 0 1 0-1.084c3.74-5.619 8.25-8.375 13.597-8.375 2.546 0 4.903.626 7.077 1.888l1.897-1.165C22.048 5.907 19.053 5 15.78 5 9.7 5 4.584 8.126.493 14.272a2.928 2.928 0 0 0 0 3.253 27.564 27.564 0 0 0 2.672 3.428l1.74-1.068a25.212 25.212 0 0 1-2.723-3.445zm5.948 6.139l-1.862 1.143c2.845 2.043 6.02 3.075 9.51 3.075 6.079 0 11.196-3.127 15.286-9.272a2.928 2.928 0 0 0 0-3.253c-.973-1.461-2.003-2.752-3.09-3.87l-1.75 1.074c1.105 1.091 2.156 2.384 3.151 3.88.22.33.22.755 0 1.084-3.74 5.62-8.25 8.375-13.596 8.375-2.771 0-5.318-.74-7.649-2.236z"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M21.612 14.306a5.85 5.85 0 0 1 .22 1.592c0 3.283-2.71 5.945-6.053 5.945a6.094 6.094 0 0 1-4.014-1.495l1.825-1.12c.63.4 1.382.633 2.189.633 2.228 0 4.035-1.774 4.035-3.963 0-.16-.01-.317-.028-.472l1.826-1.12zm-2.321-3.25a6.1 6.1 0 0 0-3.512-1.102c-3.343 0-6.053 2.661-6.053 5.944 0 .334.028.66.081.979l1.942-1.192c.113-2.09 1.874-3.75 4.03-3.75.557 0 1.089.111 1.572.312l1.94-1.19z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M30.574 6.734L32 8.974 2.627 27l-1.426-2.24L30.574 6.733z"
});

var SvgHide = function SvgHide(props) {
  return React.createElement("svg", _extends({
    fill: "#1B1F23",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "2c95302b0d4d3db7e989c23f1d413207.svg";
export { SvgHide as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ../icons/svg/hide.svg
// module id = null
// module chunks = 